import React, { useState, useEffect } from "react";
import ImagePlaceholder from "./ImagePlaceholder";

/** Renders an <img> but falls back to a branded placeholder on empty/broken src. */
const SafeImage = ({ src, alt = "", className = "", placeholderLabel, loading = "lazy" }) => {
  const [errored, setErrored] = useState(false);

  useEffect(() => { setErrored(false); }, [src]);

  if (!src || errored) {
    return <ImagePlaceholder className={className} label={placeholderLabel} />;
  }
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      onError={() => setErrored(true)}
    />
  );
};

export default SafeImage;
